import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { HelpCentrePage } from "@/features/helpcentre/HelpCentrePage";

const search = z.object({
  status: z.enum(["all", "published", "draft"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/help-centre/")({
  validateSearch: search,
  component: () => <HelpCentrePage search={Route.useSearch()} />,
});
